import React from 'react';
import { Outlet, NavLink } from 'react-router-dom';
import { Home, BarChart3, ShieldOff, Settings as SettingsIcon } from 'lucide-react';
import Navbar from '../Navbar';

const NAV = [
  { to: '/', label: 'Home', Icon: Home, end: true },
  { to: '/dashboard', label: 'Dashboard', Icon: BarChart3 },
  { to: '/blocklist', label: 'Block', Icon: ShieldOff },
  { to: '/settings', label: 'Settings', Icon: SettingsIcon },
];

function bottomNavClass({ isActive }) {
  return [
    'flex flex-col items-center justify-center flex-1 py-1 text-xs font-medium transition-colors',
    isActive ? 'text-primary-500 dark:text-primary-400' : 'text-gray-500 dark:text-night-muted',
  ].join(' ');
}

export default function Layout() {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-night-bg pb-20 md:pb-0">
      <Navbar />
      <main className="max-w-2xl mx-auto px-4 py-4">
        <Outlet />
      </main>
      <nav
        className="fixed bottom-0 left-0 right-0 z-30 md:hidden bg-white dark:bg-night-surface border-t border-gray-200 dark:border-night-card safe-area-bottom"
        aria-label="Primary"
      >
        <div className="flex h-16">
          {NAV.map(({ to, label, Icon, end }) => (
            <NavLink key={to} to={to} end={end} className={bottomNavClass}>
              <Icon className="w-5 h-5 mb-0.5" aria-hidden="true" />
              <span>{label}</span>
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
